import React, { useEffect, useMemo, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Sidebar from "../../components/Sidebar";
import Main from "./Service/Main";
import Form from "./Service/Form";
import { getAlert, getDataWithComp } from "../../../utils/SamuiUtils";
import { getReport } from "../../../utils/ReportUtils";

const Service = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [mode, setMode] = useState("");
  const [dataMasterList, setDataMasterList] = useState([]);
  const [selectedData, setSelectedData] = useState(null);
  const [formData, setFormData] = useState({});
  const companyId = useMemo(() => localStorage.getItem("company") || "", []);

  useEffect(() => {
    initialize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const initialize = async () => {
    try {
      setSelectedData(null);
      setFormData({});
      const masterList = await fetchRealtime();

      if (location.state?.create) {
        await onPageInsert(masterList);
      } else if (location.state?.editServiceId) {
        const item = (masterList || []).find(
          (d) => d.Service_Id === location.state.editServiceId
        );
        if (item) onRowSelectedItem(item);
        else setMode("S");
      } else {
        setMode("S");
      }
    } catch (error) {
      getAlert("FAILED", error.message || "ไม่สามารถโหลดข้อมูลได้");
    }
  };

  const fetchRealtime = async () => {
    try {
      const masterList = await getDataWithComp(
        "Tb_Set_Service",
        "ORDER BY Service_Id"
      );
      if (Array.isArray(masterList)) {
        setDataMasterList(masterList);
        return masterList;
      } else {
        setDataMasterList([]);
        return [];
      }
    } catch (error) {
      getAlert("FAILED", error.message || "ไม่สามารถโหลดข้อมูลได้");
      return [];
    }
  };

  const onRowSelectedItem = (item) => {
    if (!item) return;
    setMode("U");
    setFormData({
      Service_Id: item.Service_Id,
      Service_Code: item.Service_Code,
      Service_Name: item.Service_Name,
      Service_Name_EN: item.Service_Name_EN || "",
      Service_Status: item.Service_Status,
      Service_Desc: item.Service_Desc || "",
      ...(hasCompIdField ? { Comp_Id: item.Comp_Id || companyId || undefined } : {}),
    });
    setSelectedData(item);
  };

  const hasCompIdField = useMemo(() => {
    if (Array.isArray(dataMasterList) && dataMasterList.length > 0) {
      return dataMasterList.some((item) =>
        Object.prototype.hasOwnProperty.call(item || {}, "Comp_Id")
      );
    }
    return Boolean(companyId);
  }, [dataMasterList, companyId]);

  const fetchNextServiceCode = (existingList) => {
    if (Array.isArray(existingList) && existingList.length > 0) {
      const maxCode = Math.max(
        0,
        ...existingList.map((item) => Number(item.Service_Code) || 0)
      );
      return String(maxCode + 1);
    }
    return "1";
  };

  const onPageInsert = async (existingList) => {
    setSelectedData(null);
    const listToUse = Array.isArray(existingList) ? existingList : dataMasterList;
    const nextCode = fetchNextServiceCode(listToUse);
    setFormData({
      Service_Code: nextCode,
      Service_Name: "",
      Service_Name_EN: "",
      Service_Status: "Y",
      Service_Desc: "",
      ...(hasCompIdField ? { Comp_Id: companyId || undefined } : {}),
    });
    setMode("I");
  };

  const onRowSelected = (itemOrId) => {
    const item =
      typeof itemOrId === "number"
        ? dataMasterList.find((data) => data.Service_Id === itemOrId)
        : itemOrId;

    if (!item) {
      getAlert("WARNING", "ไม่พบข้อมูลบริการที่เลือก");
      return;
    }

    setMode("U");
    setFormData({
      Service_Id: item.Service_Id,
      Service_Code: item.Service_Code,
      Service_Name: item.Service_Name,
      Service_Name_EN: item.Service_Name_EN || "",
      Service_Status: item.Service_Status,
      Service_Desc: item.Service_Desc || "",
      ...(hasCompIdField ? { Comp_Id: item.Comp_Id || companyId || undefined } : {}),
    });
    setSelectedData(item);
  };

  const returnToServiceStep = (serviceId) => {
    // Navigate back to ServiceStep page with the created service ID
    navigate("/servicestep", { state: { selectServiceId: serviceId } });
  };

  return (
    <div className="Service">
      <div className="wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="container">
            <div className="page-inner">
              {mode === "S" ? (
                <Main
                  masterList={dataMasterList}
                  name={"ข้อมูลบริการ"}
                  onPageInsert={onPageInsert}
                  onRowSelected={onRowSelected}
                  getReport={(serviceId) => getReport('method', serviceId)}
                />
              ) : (
                <Form
                  callInitialize={initialize}
                  mode={mode}
                  name={"ข้อมูลบริการ"}
                  formData={formData}
                  setFormData={setFormData}
                  selectedData={selectedData}
                  masterList={dataMasterList}
                  setMode={setMode}
                  returnToServiceStep={location.state?.create ? returnToServiceStep : undefined}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Service;
